import React from "react";
import { Button } from "./ui/button";

const Regulations = () => {
  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto bg-[#f8fafc] rounded-lg p-8 lg:p-12 border border-gray-100 text-center">
          <h2 className="text-2xl lg:text-3xl font-bold text-[#012d5c] mb-6">
            Since 2018, medical cannabis can be prescribed in the UK.
          </h2>
          <p className="text-lg text-gray-600 mb-8 leading-relaxed">
            Medical cannabis has been legal in the UK since November 2018, when the law was changed to allow specialist doctors to prescribe cannabis-based products for medicinal use (CBPMs). Our clinic operates fully within these regulations, providing safe and legal access to medical cannabis for qualifying patients under the care of experienced specialists. All our products are pharmaceutical grade and meet the highest quality standards.
          </p>
          <Button 
            className="bg-[#005eb8] hover:bg-[#004a94] text-white px-8 py-6 rounded-lg text-lg"
            onClick={() => window.open("https://www.nhs.uk/conditions/medical-cannabis/", "_blank")}
          >
            Learn More About Regulations
          </Button>
        </div>
      </div>
    </section>
  );
};

export default Regulations;
